import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath } from '@uswitch/spark.utils';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'input'
});
var containerVariantPath = getVariantPath({
  id: 'input',
  element: 'container'
});
var leftIconVariantPath = getVariantPath({
  id: 'input',
  element: 'leftElement'
});
var rightIconVariantPath = getVariantPath({
  id: 'input',
  element: 'rightElement'
});
export var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'div' : _ref$as,
      isError = _ref.isError,
      isSuccess = _ref.isSuccess,
      onChangeHandler = _ref.onChangeHandler,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["as", "isError", "isSuccess", "onChangeHandler", "leftIcon", "rightIcon", "children", "className"]);

  var _useState = useState(!(props.defaultValue || props.value)),
      _useState2 = _slicedToArray(_useState, 2),
      isEmpty = _useState2[0],
      setEmpty = _useState2[1];

  var styleClasses = isEmpty ? ['_spark_input_empty'] : [];

  if (leftIcon) {
    styleClasses.push('_spark_input_left-element');
  }

  if (rightIcon) {
    styleClasses.push('_spark_input_right-element');
  }

  var variant;

  if (isError) {
    variant = variantPath('error');
  } else if (isSuccess) {
    variant = variantPath('success');
  } else {
    variant = variantPath('basic');
  }

  var inputElement = _jsx("input", _objectSpread(_objectSpread({
    className: cn(styleClasses),
    sx: {
      variant: variant
    },
    onChange: function onChange(e) {
      setEmpty(!e.target.value);

      if (onChangeHandler) {
        onChangeHandler(e);
      }
    }
  }, props), {}, {
    ref: ref
  }));

  return _jsxs(As, {
    className: className,
    sx: {
      variant: containerVariantPath('base')
    },
    children: [inputElement, leftIcon && _jsx("div", {
      sx: {
        variant: leftIconVariantPath('base')
      },
      children: leftIcon
    }), rightIcon && _jsx("div", {
      sx: {
        variant: rightIconVariantPath('base')
      },
      children: rightIcon
    })]
  });
});
Input.propTypes = {
  /**
   * Signal that this component is in the error state by applying appropriate styling
   */
  isError: PropTypes.bool,

  /**
   * Signal that this component is in the success state by applying appropriate styling
   */
  isSuccess: PropTypes.bool,

  /**
   * The icon to display before text input
   */
  leftIcon: PropTypes.element,

  /**
   * The icon to display after text input
   */
  rightIcon: PropTypes.element,

  /**
   * Should be used instead of onChange since onChange is already assigned internally,
   * unless that is the explicit intention.
   */
  onChangeHandler: PropTypes.func
};
Input.defaultProps = {
  isError: false,
  isSuccess: false
};